import React from 'react';
import styled from 'styled-components';
import Frame1Image from '../assets/Frame1.png';
import FrameImage from '../assets/Frame.png';
import OnImage from '../assets/On.png';

const DeleteAccountVendor: React.FC = () => {
  return (
    <Container>
      <ContentWrapper>
        {/* Step 1 */}
        <StepSection>
          <StepTitle>Step 1: How to Delete Venue Account</StepTitle>
          
          <InstructionText>
            Go to profile tab in vendor app click on
          </InstructionText>

          <ImageContainer>
            <StepImage src={Frame1Image} alt="Profile screen with delete account option" />
          </ImageContainer>

          <StepsList>
            <StepItem>
              <StepNumber>1</StepNumber>
              <StepText>Open the vendor app and navigate to the Profile tab</StepText>
            </StepItem>
            <StepItem>
              <StepNumber>2</StepNumber>
              <StepText>Scroll down to the "Others" section</StepText>
            </StepItem>
            <StepItem>
              <StepNumber>3</StepNumber>
              <StepText>Tap on "Delete venue account" option</StepText>
            </StepItem>
          </StepsList>
        </StepSection>

        {/* Step 2 */}
        <StepSection>
          <StepTitle>Step 2: Delete venue account</StepTitle>
          
          <ImageContainer>
            <StepImage src={FrameImage} alt="Delete account confirmation" />
          </ImageContainer>
        </StepSection>

        {/* Step 3 */}
        <StepSection>
          <StepTitle>Step 3: Account Deleted Successfully</StepTitle>
          
          <ImageContainer>
            <SuccessImage src={OnImage} alt="Account deleted successfully" />
          </ImageContainer>
        </StepSection>
      </ContentWrapper>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  font-family: 'Hanken Grotesk', sans-serif;
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 48px;
  padding: 24px 0;
`;

const StepSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const StepTitle = styled.h2`
  font-size: 22px;
  font-weight: 600;
  color: #1f2933;
  text-align: center;
  margin: 0 0 24px;
`;

const InstructionText = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: #1f2933;
  text-align: center;
  margin: 0 0 24px;
  line-height: 1.5;
`;

const StepsList = styled.ol`
  list-style: none;
  padding: 0;
  margin: 24px 0 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const StepItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  background: #f9fafb;
  border-radius: 8px;
  border-left: 3px solid #B02E2F;
`;

const StepNumber = styled.div`
  min-width: 32px;
  height: 32px;
  background: #B02E2F;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
`;

const StepText = styled.p`
  font-size: 16px;
  color: #374151;
  margin: 0;
  line-height: 1.5;
  flex: 1;
`;

const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 24px 0;
`;

const StepImage = styled.img`
  max-width: 60%;
  max-height: 400px;
  width: auto;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  object-fit: contain;
  
  @media (max-width: 768px) {
    max-width: 70%;
    max-height: 350px;
  }
`;

const SuccessImage = styled.img`
  max-width: 50%;
  max-height: 300px;
  width: auto;
  height: auto;
  border-radius: 8px;
  object-fit: contain;
  
  @media (max-width: 768px) {
    max-width: 60%;
    max-height: 250px;
  }
`;

export default DeleteAccountVendor;

